import {Button} from 'antd'
import {course_getCourses_Api,} from 'apis'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useEffect, useMemo, useState,} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {BsCloudDownload, BsCloudUpload} from 'react-icons/bs'
import {PiBooks, PiCertificate} from 'react-icons/pi'
import {TbCertificate, TbCertificateOff} from 'react-icons/tb'
import {RiSubscript} from 'react-icons/ri'
import {useLocation} from 'react-router-dom'
import {course_status_options, CourseActionTypes} from 'views/AppLocals/Course'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import CourseFilter from '../components/filters/CourseFilter'
import {FaAward} from "react-icons/fa6";
import {copyLocationParam, getRouteSearchParams, useRouteSearchParam} from "../../../../envs/_current/history";
import {MdOutlineControlPointDuplicate} from "react-icons/md";
import {LuArrowRightLeft, LuGraduationCap} from "react-icons/lu";
import {CourseContainerContext} from "./CourseContainer";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import {useCourseForm} from "../../../AppLocals/Course/CourseClass/useCourseForm";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import classNames from "classnames";
import {EntityPaginationMeta} from "../../../AppLocals/EntityList";
import {CourseStates} from "../WorkspaceCourse";
import {GoDotFill} from "react-icons/go";

const HeaderContentByStatus = {
    enrollment_open: {
        title: 'enrolling courses',
        description: 'track courses currently open for enrollment. select a course to view and manage its details',
    },
    in_process: {
        title: 'active courses',
        description: 'track courses currently being taught. select a course to view and manage its details',
    },
    completed: {
        title: 'completed courses',
        description: 'look up completed courses. select a course to view and manage its details',
    },
}

const renderGridMeta = (props) =>
    (
        <LayoutContext.Consumer>
            {({isLg}) => (
                <div className={classNames(isLg ? 'col-span-2' : 'col-span-1')}>
                    <EntityPaginationMeta
                        {...props}
                        style={{position: 'inherit'}}
                    />
                </div>
            )}
        </LayoutContext.Consumer>
    )

const Courses = ({
                     owner_id,
                     owner_type,
                     fixed_status_text = null,
                     filter_actions = {
                         sortBy: 'sort-by',
                         keyword: 'keyword',
                         status: 'course-status',
                         academic_year: 'academic-year',
                         academic_field: 'academic-field'
                     },
                 }) => {
    const t = useTranslate()

    const history = useHistory()

    const location = useLocation()

    const [refreshKey, setRefreshKey] = useState()

    const {onChangeSearchParams} = useRouterSearchParam({})
    const {onSelectCourseContainerRoute, setCurrentCourseId} = useContext(CourseContainerContext)

    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const status = useRouteSearchParam(filter_actions.status)
    const academic_year = useRouteSearchParam(filter_actions.academic_year) || ""
    const academic_field = useRouteSearchParam(filter_actions.academic_field) || ""

    let timeout
    useEffect(() => {
        if (fixed_status_text) return
        const searchParams = getRouteSearchParams()
        searchParams.set(filter_actions.status, course_status_options.normal.value)
        timeout = setTimeout(() => {
            history.replace({
                ...copyLocationParam(window.location ?? {}),
                search: '?' + searchParams.toString(),
            })
        })
        return () => clearTimeout(timeout)
    }, [])


    const {
        modal, modalIO,
        handleAction,
        onCancel,
        refreshKey: refreshKeyFromForm
    } = useCourseForm({owner_id, owner_type})

    useEffect(() => {
        setRefreshKey(refreshKeyFromForm)
    }, [refreshKeyFromForm])

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <MdOutlineControlPointDuplicate size={14} className="text-green-500"/>,
                        label: 'copy course',
                        key: CourseActionTypes.COURSE_COPY,
                    },
                    {
                        icon: <LuGraduationCap size={14} className="text-indigo-500"/>,
                        label: 'promote students',
                        key: CourseActionTypes.COURSE_PROMOTE,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: CourseActionTypes.COURSE_UPDATE,
                    },
                    {
                        icon: <RiSubscript size={14} className="text-color-200"/>,
                        label: 'subjects of course',
                        key: CourseActionTypes.SHOW_SUBJECT_LIST_MODAL,
                    },
                    {
                        type: 'divider',
                    },
                    {
                        icon: <LuArrowRightLeft size={14} className="text-green-500"/>,
                        label: 'import / export data',
                        children: [
                            {
                                key: "COURSE_STUDENT_IMPORT",
                                label: 'import student data',
                                icon: <BsCloudUpload size={14} className="text-color-300"/>,
                            },
                            {
                                key: "COURSE_STUDENT_EXPORT",
                                label: 'export student data',
                                icon: <BsCloudDownload size={14} className="text-color-300"/>,
                            },
                            {
                                key: "COURSE_ATTENDANCE_IMPORT",
                                label: 'import attendance data',
                                icon: <BsCloudUpload size={14} className="text-color-300"/>,
                            },
                            {
                                key: "COURSE_ATTENDANCE_EXPORT",
                                label: 'export attendance data',
                                icon: <BsCloudDownload size={14} className="text-color-300"/>,
                            },
                            {
                                key: "COURSE_GRADE_IMPORT",
                                label: 'import grade data',
                                icon: <BsCloudUpload size={14} className="text-color-300"/>,
                            },
                            {
                                key: "COURSE_GRADE_EXPORT",
                                label: 'export grade data',
                                icon: <BsCloudDownload size={14} className="text-color-300"/>,
                            },
                        ],
                    },
                    {
                        icon: <PiCertificate size={14} className="text-green-500"/>,
                        label: 'certification',
                        disabled: !!!item?.medal,
                        children: [
                            {
                                key: "COURSE_MEDAL_GRANT_TO_ALL_STUDENTS",
                                label: 'grant to all students',
                                icon: <TbCertificate size={14} className="text-green-600"/>,
                                disabled: !!!item?.medal,
                            },
                            {
                                key: "COURSE_MEDAL_REVOKE_ALL_TO_STUDENTS",
                                label: 'revoke all from students',
                                icon: <TbCertificateOff size={14} className="text-red-600"/>,
                                disabled: !!!item?.medal,
                            },
                            {
                                key: "COURSE_MEDAL_ISSUE_IF_ELIGIBLE",
                                label: 'issue 3rd certificate',
                                icon: <FaAward size={14} className="text-color-300"/>,
                                disabled: !!!item?.medal,
                            }
                        ],
                    },
                    {
                        type: 'divider',
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: CourseActionTypes.COURSE_DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type,
            hideStatusFilter: !!fixed_status_text,
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                status: fixed_status_text ? undefined : status,
                status_text: fixed_status_text || undefined,
                academic_year,
                academic_field
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            renderItem: renderCourse({
                translate: t,
                onSelectCourseContainerRoute,
                renderContextMenu
            }),
            PaginationMeta: NullAsDefault,
            apiInfo: course_getCourses_Api,
            query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
            renderWrap: (child) => (
                <div className="flex flex-col divide-y divide-gray-200 list-item-workspace">
                    {child}
                </div>
            )
        },
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        isToggleDefault: false,
        query_params: filter_actions,
        AdvancedFilter: CourseFilter,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
    })


    const {title, description} = HeaderContentByStatus[fixed_status_text] ?? {
        title: 'overview',
        description: 'this is the course library used to build content for courses. manage documents, sample lectures, and assessment standards',
    }

    return (
        <div className="flex flex-1 flex-col space-y-3">
            <div className="flex flex-col md:flex-row md:items-center gap-3">
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                        {t(title)}
                    </h2>
                    <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                    <div className="mt-1 mr-4 text-sm text-color-300 tracking-wider">
                        {t(description)}
                    </div>
                </div>
                <Button
                    color="primary" variant="solid"
                    className="px-6 py-2 font-semibold rounded-lg"
                    onClick={() => {
                        handleAction(CourseActionTypes.COURSE_CREATE)
                    }}>
                    {t('create course')}
                </Button>
            </div>
            {pager_widget}
            {modal}
            {!!modalIO ? modalIO : null}
            <div className="h-16"/>
        </div>
    )
}


const accentBarClass = {
    enrollment_open: 'bg-green-400',
    in_process:      'bg-blue-400',
    completed:       'bg-primary-400',
}

const renderCourse = ({onSelectCourseContainerRoute, translate: t, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {
        time_open,
        time_close,
        course_state,
        course_class_count,
        student_count,
        curriculum,
        description,
    } = item ?? {}

    const stateInfo = _.find(CourseStates, {value: course_state})

    return (
        <div key={index} className="p-4 flex transition-all duration-300 custom-item-render relative list-item">
            {/*<div className={classNames('w-1 flex-shrink-0', accentBarClass[course_state] ?? 'bg-color-100')}/>*/}

            <div className="flex flex-col flex-1 min-w-0">
                {/* Title + status + curriculum cùng hàng */}
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                    <h2
                        onClick={() => onSelectCourseContainerRoute({current_course_id: item.id})}
                        className="min-w-0 basis-full sm:basis-auto font-bold text-lg text-color-000 hover:text-primary cursor-pointer leading-snug truncate">
                        {item.title}
                    </h2>
                    {/* Status */}
                    {stateInfo && (
                        <span
                            style={{ fontSize: 11 }}
                            className={classNames(
                                'px-2 py-0.5 flex flex-center flex-shrink-0 font-semibold rounded-full whitespace-no-wrap tracking-wider',
                                stateInfo.className
                            )}>
                            {t(stateInfo.label)}
                        </span>
                    )}
                    {/* Curriculum */}
                    {curriculum?.title && (
                        <span className="px-2 py-0.5 flex flex-center flex-shrink-0 gap-1 bg-color-50 border border-color-200 text-color-100 rounded-full">
                            <PiBooks size={12} className="flex-shrink-0"/>
                            <span className="font-medium text-2xs tracking-wider truncate">
                                {curriculum.title}
                            </span>
                        </span>
                    )}
                </div>
                <div className="my-2 border-b border-color-50"/>
                {/* Meta */}
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    {time_open && (
                        <span className="flex items-center gap-1 font-medium text-xs text-color-100 italic">
                            <GoDotFill size={10} className="text-color-500"/>
                            {formatSimplifyDate(time_open, 'medium')}
                            {time_close && ` → ${formatSimplifyDate(time_close, 'medium')}`}
                        </span>
                    )}
                    {course_class_count > 0 && (
                        <span className="flex items-center gap-1 font-medium text-xs text-color-100 italic">
                            <GoDotFill size={10} className="text-color-500"/>
                            {`${course_class_count} ${t('classes').toLowerCase()}`}
                        </span>
                    )}
                    {student_count > 0 && (
                        <span className="flex items-center gap-1 font-medium text-xs text-color-100 italic">
                            <GoDotFill size={10} className="text-color-500"/>
                            {`${student_count} ${t('students').toLowerCase()}`}
                        </span>
                    )}
                </div>

                <div className="mt-1 text-color-300 tracking-wider">
                    {description}
                </div>
            </div>

            {_.isFunction(renderContextMenu) && (
                <div className="absolute right-8 top-8 contextIcon">
                    {renderContextMenu(item)}
                </div>
            )}
        </div>
    )
}


export default Courses
